module.exports = __webpack_public_path__ + "static/media/coffin.f4ce1fbf.svg";